import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { ExternalLinkAltIcon } from "@patternfly/react-icons";

import {
  rodoDocuments,
  rodoImage
} from "./data/rodoDocuments";

const RodoPage = () => {

  const electronicJournalInformation = [
    <>
      W Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku,
      ul. Wiejska 1, 89-300 Wyrzysk, dokumentację szkolną prowadzi się
      z wykorzystaniem dzienników w formie papierowej. Dziennik elektroniczny
      udostępniony za pośrednictwem strony internetowej{" "}
      <a
        href="https://uonetplus.vulcan.net.pl/powiatpilski"
        target="_blank"
        rel="noopener noreferrer"
      >
        uonetplus.vulcan.net.pl/powiatpilski
      </a>{" "}
      pełni funkcję wspomagającą.
    </>,

    <>
      Oprogramowanie oraz usługi związane z jego obsługą dostarczane są przez
      firmę zewnętrzną VULCAN sp. z o.o., ul. Wołowska 6, 51-116 Wrocław.
      Podstawą działania dziennika elektronicznego jest umowa podpisana przez
      Dyrektora Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku oraz
      uprawnionego przedstawiciela firmy dostarczającej i obsługującej system
      dziennika elektronicznego.
    </>,

    <>
      Za niezawodność działania systemu, ochronę danych osobowych umieszczonych
      na serwerach oraz tworzenie kopii bezpieczeństwa odpowiada firma
      nadzorująca pracę dziennika elektronicznego oraz pracownicy szkoły, którzy
      mają bezpośredni dostęp do edycji i przeglądania danych. Szczegółową
      odpowiedzialność obu stron reguluje zawarta pomiędzy stronami umowa oraz
      przepisy obowiązującego w Polsce prawa.
    </>,

    <>
      Administratorem danych osobowych jest Dyrektor Centrum Kształcenia
      Zawodowego i Ustawicznego w Wyrzysku, ul. Wiejska 1, 89-300 Wyrzysk,
      tel.:{" "}
      <a href="tel:+48672867709">
        67 286 77 09
      </a>
      , e-mail:{" "}
      <a href="mailto:sekretariat@zspwyrzysk.pl">
        sekretariat@zspwyrzysk.pl
      </a>
      . Dyrektor szkoły nie jest zobligowany do zbierania dodatkowej zgody od
      rodziców lub prawnych opiekunów na przetwarzanie danych osobowych
      związanych z działaniem dziennika elektronicznego, wynikających
      z przepisów prawa.
    </>,

    <>
      Celem przetwarzania danych osobowych jest realizacja obowiązków
      wynikających z Rozporządzenia Ministra Edukacji Narodowej z dnia
      29 sierpnia 2014 r. w sprawie sposobu prowadzenia przez publiczne
      przedszkola, szkoły i placówki dokumentacji przebiegu nauczania,
      działalności wychowawczej i opiekuńczej oraz rodzajów tej dokumentacji.
    </>,

    <>
      W dzienniku elektronicznym umieszcza się w szczególności: oceny
      cząstkowe, oceny śródroczne i roczne, frekwencję, tematy zajęć i terminy
      sprawdzianów, uwagi uczniów, zastępstwa oraz wybrane zadania domowe.
      Udostępniane są komunikaty pomiędzy pracownikami szkoły a ich rodzicami
      lub prawnymi opiekunami.
    </>,

    <>
      Użytkownicy e-dziennika: upoważnieni pracownicy szkoły, rodzice
      i uczniowie zobowiązani są do stosowania zasad zawartych w przepisach
      wewnętrznych szkoły i ogólnie obowiązujących, dotyczących ochrony danych
      osobowych.
    </>,

    <>
      Wszystkie moduły składające się na dziennik elektroniczny zapewniają
      realizację zapisów, które zamieszczone są w ocenianiu wewnątrzszkolnym.
    </>,

    <>
      Rodzicom na pierwszym zebraniu w nowym roku szkolnym zapewnia się
      możliwość zapoznania się ze sposobem działania i funkcjonowania
      dziennika elektronicznego.
    </>,

    <>
      Dostęp do dziennika elektronicznego jest bezpłatny dla wszystkich
      użytkowników.
    </>
  ];
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>

        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    RODO
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Informacje i dokumenty dotyczące ochrony
                    danych osobowych.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Content>
                    <List isPlain>
                      {rodoDocuments.map((document) => (
                        <ListItem key={document.id}>
                          <a
                            href={document.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {document.title}{" "}
                            <ExternalLinkAltIcon />
                          </a>
                        </ListItem>
                      ))}
                    </List>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>

        {/* <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Content>
                    <h2>Dziennik elektroniczny</h2>

                    <ol>
                      {electronicJournalInformation.map(
                        (information, index) => (
                          <li key={index}>
                            {information}
                          </li>
                        )
                      )}
                    </ol>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem> */}
        <StackItem>
  <Grid>
    <GridItem
      span={12}
      md={8}
      mdOffset={2}
    >
      <Card isGlass>
        <CardBody>
          <Stack hasGutter>
            <StackItem>
              <Content>
                <h2>Dziennik elektroniczny</h2>
              </Content>
            </StackItem>

            <StackItem>
              <img
                src={rodoImage}
                alt="Dziennik elektroniczny VULCAN"
                style={{
                  display: "block",
                  width: "100%",
                  maxWidth: "640px",
                  height: "auto",
                  marginInline: "auto",
                  objectFit: "contain"
                }}
              />
            </StackItem>

            <StackItem>
                      <Content>
                        <ol>
                          {electronicJournalInformation.map(
                            (information, index) => (
                              <li key={index}>
                                {information}
                              </li>
                            )
                          )}
                        </ol>
                      </Content>
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>

      </Stack>
    </PageSection>
  );
};

export default RodoPage;